// extracted by mini-css-extract-plugin
module.exports = {"halfWidth":"styles_halfWidth__28Pse","fullWidth":"styles_fullWidth__327G2","label":"styles_label__3jG_k"};